import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './firebase/AuthContext';
import Login from './pages/Login';
import Upload from './pages/Upload';
import ReviewBubbles from './pages/ReviewBubbles';
import FAIDocument from './pages/FAIDocument';
import FinalInspection from './pages/FinalInspection';
import Exports from './pages/Exports';
import Team from './pages/Team';
import PaywallScreen from './pages/PaywallScreen';
import './App.css';
 
function ProtectedRoute({ children }) {
  const { user, loading, trialExpired, planExpired } = useAuth();
 
  if (loading) return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#0d1b2a', color: '#3b82f6',
      fontSize: '16px', fontFamily: 'Inter, sans-serif'
    }}>
      Loading MIA...
    </div>
  );
 
  if (!user) return <Navigate to="/login" />;
 
  // Trial ended — show paywall with pricing
  if (trialExpired) return <PaywallScreen reason="trial" />;
 
  // Plan expired / account suspended — show paywall
  if (planExpired) return <PaywallScreen reason="suspended" />;
 
  return children;
}
 
function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
          <Route path="/review/:projectId" element={<ProtectedRoute><ReviewBubbles /></ProtectedRoute>} />
          <Route path="/fai/:projectId" element={<ProtectedRoute><FAIDocument /></ProtectedRoute>} />
          <Route path="/final/:projectId" element={<ProtectedRoute><FinalInspection /></ProtectedRoute>} />
          <Route path="/exports/:projectId" element={<ProtectedRoute><Exports /></ProtectedRoute>} />
          <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
 
export default App;